module.exports = __webpack_public_path__ + "img/todo-o.9ba450b9.svg";